// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const VerticalArrows: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="8" viewBox="0 0 6 8"><path fill="#666" fill-rule="evenodd" d="M5.49535893,3.35694644 C5.94411234,3.35694644 6.16846856,2.83646711 5.85183877,2.53303406 L3.35647985,0.141678625 C3.15935927,-0.0472262084 2.84064073,-0.0472262084 2.6456089,0.141678625 L0.148161228,2.53303406 C-0.168468562,2.83646711 0.0558876647,3.35694644 0.504641074,3.35694644 L5.49535893,3.35694644 Z M3.35647985,7.85832137 L5.85183877,5.46696594 C6.16846856,5.16353289 5.94411234,4.64305356 5.49535893,4.64305356 L0.504641074,4.64305356 C0.0558876647,4.64305356 -0.168468562,5.16353289 0.148161228,5.46696594 L2.6456089,7.85832137 C2.84064073,8.04722621 3.15935927,8.04722621 3.35647985,7.85832137 Z"/></svg>
    );
};

export default React.memo(VerticalArrows);
